import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import _ from 'lodash';
import { WalletContext } from '../wallet';
import { ethers } from 'ethers';
import { addressOfByRegistry, createERC20Controller, getContractAddresses } from '../contracts-controller';
export const REDUCER_NAME = 'token';

export const ContextTokens: { [key in string]: { [key in string]: Erc20TokenInfo } } = {};

/**
 * 加载 token
 */
export const loadTokenInfo = createAsyncThunk(REDUCER_NAME + '/loadTokenInfo', async (token: string, api) => {
    // 从 name -> address
    let address = ethers.utils.isAddress(token) ? token : getContractAddresses([token])[0];
    if (!ethers.utils.isAddress(address)) {
        address = await addressOfByRegistry(token);
    }
    if (!ethers.utils.isAddress(address)) {
        console.log(`Token[${token}] load fail`);
        return;
    }
    const tokenController = await createERC20Controller(address);
    if (!tokenController) {
        console.log(`Token[${token}] load fail`);
        return;
    }
    const name = await tokenController.name();
    const symbol = await tokenController.symbol();
    const decimals = await tokenController.decimals();
    const totalSupply = await tokenController.totalSupply();
    const tokenInfo: Erc20TokenInfo = {
        address: address,
        name,
        symbol,
        decimals,
        totalSupply,
    };
    api.dispatch(setToken({ addressList: [address, token], tokenInfo }));
});

const tokenSlice = createSlice({
    name: REDUCER_NAME,
    initialState: {
        counter: 0,
    } as TokenRecuderContext,
    reducers: {
        setToken: (state, action: PayloadAction<{ addressList: string[]; tokenInfo: Erc20TokenInfo }>) => {
            // 先获取缓存中的数据
            if (!WalletContext.Chain) {
                return;
            }
            // if (!ContextTokens[WalletContext.Wallet.chain.name]) {
            //     ContextTokens[WalletContext.Wallet.chain.name] = {};
            // }
            // const tokens = ContextTokens[WalletContext.Wallet.chain.name];
            if (!ContextTokens[WalletContext.Chain.name]) {
                ContextTokens[WalletContext.Chain.name] = {};
            }
            const tokens = ContextTokens[WalletContext.Chain.name];
            let isCounter = 0;
            _.forEach(action.payload.addressList, (str) => {
                if (tokens[str]) {
                    return;
                }
                tokens[str] = action.payload.tokenInfo;
                isCounter++;
            });
            if (isCounter == 0) {
                return;
            }
            state.counter++;
        },
    },
});
export const { setToken } = tokenSlice.actions;
export default tokenSlice.reducer;
